// --------------------------
// IMPORTS
// --------------------------
import { useEffect, useState } from "react";
import AddForm from "../../components/molecules/Forms/addForm";
import { useDispatch, useSelector } from "react-redux";
import UndelegateAccess from "../UndelegateAccess";
import { addDelegateAccessThunk } from "../../store/thunks/delegateAccessThunk";
import { getUserListWithDetailThunk } from "../../store/thunks/masterDataThunk";
import { decryptData } from "../../utils/Constants";
import { bumpDelegatedAccessVersion } from "../../store/slices/delegateAccessSlice";
import dayjs from "dayjs";
//import { updateUserDelegationFlags } from "../../store/slices/authSlice";

// --------------------------
// MAIN COMPONENT
// --------------------------
const DelegateAccess = (props) => {
  // --------------------------
  // PROPS
  // --------------------------
  const { isDelegateModalOpen, setIsDelegateModalOpen, setShowLoader, givenDelegatedAccess } = props;

  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  //const currentPath = useCurrentPath();

  // --------------------------
  // REDUX STATE
  // --------------------------
  const storeLIUId = useSelector((state) => state.auth.lIUId);
  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);
  
  // --------------------------
  // LOCAL STATES
  // --------------------------
  const [employees, setEmployees] = useState([]);
  // const [hasDelegatedAccess, setHasDelegatedAccess] = useState(false);
  //const [givenDelegatedAccess, setGivenDelegatedAccess] = useState(false);
  // const givenDelegatedAccess = useSelector(
  //   (state) => state.auth.givenDelegatedAccess
  // );

  // --------------------------
  // USE EFFECTS
  // --------------------------
  useEffect(() => {
    dispatch(getUserListWithDetailThunk())
      .unwrap()
      .then((res) => {
        if (Array.isArray(res)) {
          const mappedEmployees = res
            ?.filter((user) => user?.empName !== undefined && user?.empID !== 1)
            ?.map((user) => ({
              label: `${user.empName} (Emp. Id. - ${user.empID})`,
              value: user.id,
            }));

          setEmployees(mappedEmployees);
        }
      });
  }, [dispatch]);

  // useEffect(() => {
  //   if (!isDelegateModalOpen) return;

  //   (async () => {
  //     const res = await dispatch(getUserListWithDetailThunk()).unwrap();
  //     const userInfo = res.find((u) => u.id === storeLIUId);
  //     // setHasDelegatedAccess(userInfo?.hasDelegatedAccess);
  //     setGivenDelegatedAccess(userInfo?.givenDelegatedAccess===undefined?false:userInfo?.givenDelegatedAccess);
  //   })();
  // }, [isDelegateModalOpen, dispatch, storeLIUId]);

  // --------------------------
  // FORM FIELDS
  // --------------------------
  const formFields = [
    {
      isVisible: true,
      label: "Employee",
      name: "employeeID",
      rules: [
        {
          required: true,
          message: "Please select an employee",
        },
      ],
      placeholder: "Select Employee",
      type: "select",
      multiple: false,
      options: employees,
      filterOption: (input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase()),
    },

    {
      isVisible: true,
      label: "Duration",
      name: "duration",
      rules: [
        {
          required: true,
          message: "Please select duration",
        },
      ],
      placeholder: "Select duration",
      type: "rangePicker",
      format: "YYYY-MM-DD",
      disabledDate: (current) =>
      current && current < dayjs().startOf("day"),
    },
    {
      isVisible: true,
      label: "Special Note",
      name: "specialNote",
      rules: [],
      placeholder: "Enter special note",
      type: "textarea",
    },
  ];
    
  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      {givenDelegatedAccess === false ? (
        <AddForm
          isVisible={isDelegateModalOpen}
          setIsVisible={setIsDelegateModalOpen}
          setShowLoader={setShowLoader}
          name="Delegate Access"
          payload={(values) => {
            const [fromDate, toDate] = values.duration;
            return {
              assignBy: storeLIUId,
              assignTo: values?.employeeID,
              fromDate: fromDate,
              toDate: toDate,
              specialNote:
                values?.specialNote ||
                "Managing expense submissions and approvals on my behalf.",
              createdAt: new Date().toISOString(),
              historySource: "backend",
              historyAction: "create",
              historyUserID: storeLIUId,
              route: "addDelegateAccess",
            };
          }}
          list={addDelegateAccessThunk}
          headers=""
          formFields={formFields}
          successMessage="Delegate access has been given successfully"
          onSuccess={async () => {
            const res = await dispatch(getUserListWithDetailThunk()).unwrap();
            const userInfo = res.find((u) => u.id === storeLIUId);            
            
            dispatch(bumpDelegatedAccessVersion());
           
          }}
        />
      ) : (
        <UndelegateAccess
          isVisible={isDelegateModalOpen}
          setIsVisible={setIsDelegateModalOpen}
          givenDelegatedAccess={givenDelegatedAccess}
          storeLIUId={storeLIUId}          
        />
      )}
    </>
  );
};

export default DelegateAccess;
